import React, { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import ContextMenu from 'flow/components/ContextMenu';
import useAppContext from 'flow/hooks/useAppContext';
import TicketContextMenuItems from 'flow/components/tickets/TicketContextMenu/TicketContextMenuItems';
import { TicketKey } from 'flow/types/EntityKeys';

type Props = {
    ticketKey: TicketKey;
};

const SectionHeaderContextMenu = ({ ticketKey }: Props) => {
    const { i18next } = useAppContext();
    const [itemIsActive, setItemIsActive] = useState(false);

    return (
        <div
            className={twMerge(
                'items-center text-gray-800',
                itemIsActive ? 'flex' : 'sr-only-until-hover-or-focus flex',
            )}
        >
            <ContextMenu
                setActive={setItemIsActive}
                preventOverflow={true}
                triggerLabel={i18next.t('menu.more_options')}
            >
                <TicketContextMenuItems ticketKey={ticketKey} />
            </ContextMenu>
        </div>
    );
};

export default React.memo(SectionHeaderContextMenu);
